export default __webpack_public_path__ + "static/media/surgery-classification.85e84f1d.svg";